import { render, staticRenderFns } from "./notice_of_negotiations.vue?vue&type=template&id=b8e7d7de&scoped=true&"
import script from "./notice_of_negotiations.vue?vue&type=script&lang=js&"
export * from "./notice_of_negotiations.vue?vue&type=script&lang=js&"
import style0 from "./notice_of_negotiations.vue?vue&type=style&index=0&id=b8e7d7de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e7d7de",
  null
  
)

export default component.exports